import React from "react"
import FormGroup from "../Form/FormGroup"
import Select from "../Form/Select"
import styles from "./leadFilters.module.css"

const collectionOperatorOptions = [
    { id: "any", value: "Qualquer um dos selecionados" },
    { id: "all", value: "Todos os selecionados" },
    { id: "exact", value: "Exatamente os selecionados" },
    { id: "none", value: "Nenhum dos selecionados" },
    { id: "is_empty", value: "Nenhum cadastrado" },
    { id: "is_not_empty", value: "Pelo menos um cadastrado" },
]

const CollectionFilter = ({ label, name, placeholder, options = [], selected = [], operator = "any", onValuesChange = () => { }, onOperatorChange = () => { } }) => {
    const presenceOperator = ["is_empty", "is_not_empty"].includes(operator)

    const changeOperator = newOperator => {
        onOperatorChange(newOperator)
        if (["is_empty", "is_not_empty"].includes(newOperator)) onValuesChange([])
    }

    return (
        <FormGroup labelText={label}>
            <div className={styles.collectionFilter}>
                <div className={styles.collectionField}>
                    <span>Como comparar</span>
                    <Select name="Condição" placeholder="Selecione uma condição" options={collectionOperatorOptions} selected={operator} onChange={changeOperator} multiple={false} allowDeselectAll={false} />
                </div>
                <div className={`${styles.collectionField} ${presenceOperator ? styles.collectionFieldDisabled : ""}`}>
                    <span>Quais valores</span>
                    <Select name={name} placeholder={presenceOperator ? "Não é necessário selecionar" : placeholder} options={options} selected={selected} onChange={onValuesChange} multiple={true} disabled={presenceOperator} />
                </div>
            </div>
        </FormGroup>
    )
}

export { collectionOperatorOptions }
export default CollectionFilter
